
var CFG = window.mpHeaderConfig || { sectionId: '', currency: 'USD', searchUrl: '/search' };
(function() {
  function initMpHeader() {
    var header = document.querySelector('.mp-header[data-section-id="' + CFG.sectionId + '"]');
    if (!header) return;

    /* Drawer */
    function setDrawer(open) {
      header.setAttribute('data-drawer-open', open ? 'true' : 'false');
      var drawer = header.querySelector('#mp-drawer');
      if (drawer) {
        if (open) {
          drawer.removeAttribute('inert');
        } else {
          /* Focus must leave before the subtree goes inert, or it falls to <body>. */
          if (drawer.contains(document.activeElement)) {
            var drawerTrigger = header.querySelector('[data-mp-drawer-open]');
            if (drawerTrigger) drawerTrigger.focus();
          }
          drawer.setAttribute('inert', '');
        }
      }
      if (document.body) document.body.classList.toggle('mp-drawer-open', open);
      var toggle = header.querySelector('[data-mp-drawer-open]');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    header.querySelectorAll('[data-mp-drawer-open]').forEach(function(b) {
      b.addEventListener('click', function() { setDrawer(true); });
    });
    header.querySelectorAll('[data-mp-drawer-close]').forEach(function(b) {
      b.addEventListener('click', function() { setDrawer(false); });
    });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') setDrawer(false); });

    header.querySelectorAll('[data-mp-acc]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var row = btn.closest('.mp-drawer__row');
        var panel = row ? row.nextElementSibling : null;
        if (!panel || !panel.hasAttribute('data-mp-acc-panel')) return;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.hidden = isOpen;
      });
    });
    var wcs = header.querySelectorAll('[data-mp-wishlist-count]');
    function mpWishlistCount() {
      if (!wcs.length) return;
      try {
        var v = localStorage.getItem('shopify-wishlist');
        var n = v ? v.split(',').filter(Boolean).length : 0;
        wcs.forEach(function(wc) { wc.textContent = n; wc.style.display = n ? '' : 'none'; });
      } catch(e) {}
    }
    mpWishlistCount();
    document.addEventListener('shopify-wishlist:updated', mpWishlistCount);
    window.addEventListener('pageshow', mpWishlistCount);

    function mpSetCartCount(n) {
      n = parseInt(n, 10) || 0;
      header.querySelectorAll('[data-mp-cart-count]').forEach(function(cc) {
        cc.textContent = n;
        cc.style.display = n > 0 ? '' : 'none';
      });
    }
    function mpRefreshCartCount() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(c) { mpSetCartCount(c.item_count); })
        .catch(function() {});
    }
    header.querySelectorAll('[data-mp-cart-count]').forEach(function(cc) {
      var v = parseInt(cc.textContent.trim(), 10) || 0;
      cc.style.display = v > 0 ? '' : 'none';
    });
    if (window.jQuery) { window.jQuery('body').on('drawer.footer', mpRefreshCartCount); }
    document.addEventListener('cart:updated', mpRefreshCartCount);
    window.addEventListener('pageshow', mpRefreshCartCount);

    var searchPanel   = header.querySelector('[data-mp-search]');
    var searchInput   = header.querySelector('[data-mp-search-input]');
    var searchResults = header.querySelector('[data-mp-search-results]');
    var searchQuick   = header.querySelector('[data-mp-search-quick]');
    var searchClear   = header.querySelector('[data-mp-search-clear]');
    var searchForm    = searchPanel ? searchPanel.querySelector('.mp-search__form') : null;

    if (searchPanel && searchInput) {
      var CURRENCY    = CFG.currency;
      var SEARCH_URL  = CFG.searchUrl;
      var searchOpen  = false;
      var debounceId  = null;
      var inflight    = null;      
      var lastQuery   = '';
      var activeIdx   = -1;       

      var money = function(value) {
        var n = parseFloat(value);
        if (isNaN(n)) return '';
        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency', currency: CURRENCY, minimumFractionDigits: 2
          }).format(n);
        } catch (e) {
          return CURRENCY + ' ' + n.toFixed(2);
        }
      };

      var thumb = function(url) {
        if (!url) return '';
        return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      };

      var setSearch = function(open) {
        searchOpen = open;
        if (open) {
          searchPanel.removeAttribute('inert');
        } else {
          /* Focus must leave before the subtree goes inert, or it falls to <body>. */
          if (searchPanel.contains(document.activeElement)) {
            var searchTrigger = header.querySelector('[data-mp-search-open]');
            if (searchTrigger) searchTrigger.focus();
          }
          searchPanel.setAttribute('inert', '');
        }
        header.querySelectorAll('[data-mp-search-open]').forEach(function(b) {
          b.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        if (open) {
          setTimeout(function() { searchInput.focus(); searchInput.select(); }, 60);
          var term = searchInput.value.trim();
          if (term.length >= 2) { lastQuery = term; fetchResults(term); }
        } else {
          clearResults();
        }
      };

      var clearResults = function() {
        if (inflight) { inflight.abort(); inflight = null; }
        if (debounceId) { clearTimeout(debounceId); debounceId = null; }
        searchResults.innerHTML = '';
        searchResults.hidden = true;
        searchInput.setAttribute('aria-expanded', 'false');
        if (searchQuick) searchQuick.hidden = false;
        activeIdx = -1;
        lastQuery = '';
      };

      var showMessage = function(text) {
        searchResults.innerHTML = '<div class="mp-search__msg"></div>';
        searchResults.firstChild.textContent = text;
        searchResults.hidden = false;
        if (searchQuick) searchQuick.hidden = true;
        activeIdx = -1;
      };

      var render = function(products, term) {
        activeIdx = -1;

        if (!products.length) {
          showMessage('No products match “' + term + '”.');
          return;
        }

        var frag = document.createDocumentFragment();

        products.forEach(function(p) {
          var a = document.createElement('a');
          a.className = 'mp-search__result';
          a.href = p.url;
          a.setAttribute('role', 'option');
          a.setAttribute('aria-selected', 'false');

          if (p.image) {
            var img = document.createElement('img');
            img.className = 'mp-search__thumb';
            img.src = thumb(p.image);
            img.alt = '';
            img.loading = 'lazy';
            img.width = 52;
            img.height = 52;
            a.appendChild(img);
          }

          var meta = document.createElement('div');
          meta.className = 'mp-search__meta';

          var title = document.createElement('div');
          title.className = 'mp-search__title';
          title.textContent = p.title;
          meta.appendChild(title);

          var priceText = '';
          if (p.price_min && p.price_max && p.price_min !== p.price_max) {
            priceText = 'From ' + money(p.price_min);
          } else if (p.price) {
            priceText = money(p.price);
          }
          if (priceText) {
            var price = document.createElement('div');
            price.className = 'mp-search__price';
            price.textContent = priceText;
            meta.appendChild(price);
          }

          a.appendChild(meta);
          frag.appendChild(a);
        });

        var all = document.createElement('a');
        all.className = 'mp-search__viewall';
        all.href = SEARCH_URL + '?q=' + encodeURIComponent(term) + '&type=product';
        all.textContent = 'View all results';
        frag.appendChild(all);

        searchResults.innerHTML = '';
        searchResults.appendChild(frag);
        searchResults.hidden = false;
        searchInput.setAttribute('aria-expanded', 'true');
        if (searchQuick) searchQuick.hidden = true;
      };

      var fetchResults = function(term) {
        if (inflight) inflight.abort();
        inflight = new AbortController();

        var url = '/search/suggest.json'
          + '?q=' + encodeURIComponent(term)
          + '&resources[type]=product'
          + '&resources[limit]=6'
          + '&resources[options][unavailable_products]=last'
          + '&resources[options][fields]=title,product_type,variants.title,tag';

        fetch(url, { signal: inflight.signal, headers: { Accept: 'application/json' } })
          .then(function(r) {
            if (!r.ok) throw new Error(r.status);
            return r.json();
          })
          .then(function(data) {
            /* A slower earlier request must not overwrite newer results */
            if (term !== lastQuery) return;
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            render(products, term);
          })
          .catch(function(err) {
            if (err && err.name === 'AbortError') return;
            /* Network/API failure: stay silent and let the form submit do the work */
            showMessage('Press Enter to search for “' + term + '”.');
          });
      };

      var onInput = function() {
        var term = searchInput.value.trim();
        if (searchClear) searchClear.hidden = !searchInput.value.length;

        if (debounceId) clearTimeout(debounceId);

        if (term.length < 2) {
          if (inflight) { inflight.abort(); inflight = null; }
          searchResults.innerHTML = '';
          searchResults.hidden = true;
          searchInput.setAttribute('aria-expanded', 'false');
          if (searchQuick) searchQuick.hidden = false;
          lastQuery = '';
          activeIdx = -1;
          return;
        }

        lastQuery = term;
        debounceId = setTimeout(function() { fetchResults(term); }, 250);
      };

      var highlight = function(dir) {
        var items = searchResults.querySelectorAll('.mp-search__result, .mp-search__viewall');
        if (!items.length) return;

        if (activeIdx > -1 && items[activeIdx]) items[activeIdx].setAttribute('aria-selected', 'false');
        activeIdx += dir;
        if (activeIdx < 0) activeIdx = items.length - 1;
        if (activeIdx >= items.length) activeIdx = 0;

        items[activeIdx].setAttribute('aria-selected', 'true');
        items[activeIdx].scrollIntoView({ block: 'nearest' });
      };

      header.querySelectorAll('[data-mp-search-open]').forEach(function(b) {
        b.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          setSearch(!searchOpen);
        });
      });
      header.querySelectorAll('[data-mp-search-close]').forEach(function(b) {
        b.addEventListener('click', function() { setSearch(false); });
      });

      if (searchClear) {
        searchClear.addEventListener('click', function() {
          searchInput.value = '';
          searchClear.hidden = true;
          clearResults();
          searchInput.focus();
        });
      }

      searchInput.addEventListener('input', onInput);
      searchInput.addEventListener('focus', function() {
        if (searchInput.value.trim().length >= 2 && searchResults.innerHTML) {
          searchResults.hidden = false;
        }
      });

      searchInput.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); highlight(1); return; }
        if (e.key === 'ArrowUp')   { e.preventDefault(); highlight(-1); return; }
        if (e.key === 'Escape')    { setSearch(false); return; }
        if (e.key === 'Enter') {
          var items = searchResults.querySelectorAll('.mp-search__result, .mp-search__viewall');
          if (activeIdx > -1 && items[activeIdx]) {
            e.preventDefault();
            window.location.href = items[activeIdx].href;
          }
        }
      });

      if (searchForm) {
        searchForm.addEventListener('submit', function(e) {
          if (!searchInput.value.trim().length) e.preventDefault();
        });
      }

      document.addEventListener('click', function(e) {
        if (!searchOpen) return;
        if (searchPanel.contains(e.target)) return;
        if (e.target.closest && e.target.closest('[data-mp-search-open]')) return;
        setSearch(false);
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && searchOpen) setSearch(false);
      });

      if (searchClear) searchClear.hidden = !searchInput.value.length;
    }

    var announceItems = header.querySelectorAll('.mp-announce__item');
    if (announceItems.length > 1) {
      var announceActiveIdx = 0;
      var announceTimer = setInterval(function() {
        // The header can be replaced by Shopify/theme section rendering.
        // Never access an undefined/stale item.
        if (!header.isConnected) {
          clearInterval(announceTimer);
          return;
        }

        var items = header.querySelectorAll('.mp-announce__item');
        if (items.length < 2) {
          clearInterval(announceTimer);
          return;
        }

        if (announceActiveIdx >= items.length) announceActiveIdx = 0;

        var currentItem = items[announceActiveIdx];
        if (currentItem) {
          currentItem.classList.remove('mp-announce__item--active');
        }

        announceActiveIdx = (announceActiveIdx + 1) % items.length;

        var nextItem = items[announceActiveIdx];
        if (nextItem) {
          nextItem.classList.add('mp-announce__item--active');
        }
      }, 2000);
    }
  }

  function boot() {
    initMpHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
